import { LyfeTooltip } from "@lyfegen-platform/react-common";
import { IconButton } from "@material-ui/core";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { useTranslation } from "react-i18next";
import { DELETE_SIMULATION } from "../queries";
import { useState } from "react";
import ModalDialog, { IText } from "../../../components/ModalDialog";
import CustomCircularProgress from "../../../components/CustomCircularProgress";
import { useModelsMutation } from "../../../hooks/useModelsModule";

interface IDeleteSimulationDialogProps {
	simulationId: string;
	deleteTrigger: (simulationId: string) => void;
}

export const DeleteSimulationDialog = (props: IDeleteSimulationDialogProps) => {
	const { t } = useTranslation();
	const [showDialog, setShowDialog] = useState<boolean>(false);

	const [deleteSimulation, { loading, error: errorDeletingSim }] = useModelsMutation(DELETE_SIMULATION, {
		onCompleted: () => {
			setShowDialog(false);
		},
	});

	const dialogText = {
		question: !errorDeletingSim && t("delete-simulation-p1"),
		reason: !errorDeletingSim && [t("delete-simulation-question", { id: props.simulationId || "" })],
		continue: loading ? <CustomCircularProgress /> : !errorDeletingSim ? t("delete-continue") : t("try-again"),
		error: !!errorDeletingSim && [t("simulator-delete-simulation-error-p1"), t("simulator-delete-simulation-error-p2")],
		discard: !errorDeletingSim ? t("no-cancel") : t("cancel"),
	} as IText;
	const handleDeleteSimulation = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		deleteSimulation({ variables: { id: props.simulationId } });
		props.deleteTrigger(props.simulationId);
	};

	const openConfirmationModal = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		openDialog();
	};

	const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		setShowDialog(false);
	};

	const openDialog = () => setShowDialog(true);

	return (
		<>
			<LyfeTooltip title={t("delete-simulation-button-hover")}>
				<IconButton onClick={openConfirmationModal}>
					<DeleteOutlinedIcon color="primary" />
				</IconButton>
			</LyfeTooltip>
			<ModalDialog isOpen={showDialog} onContinueClick={handleDeleteSimulation} onDiscardClick={handleClose} text={dialogText} />
		</>
	);
};
